import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-hbar-engagement-rate-per-entity',
  templateUrl: './hbar-engagement-rate-per-entity.component.html',
  styleUrl: './hbar-engagement-rate-per-entity.component.scss',
})
export class HbarEngagementRatePerEntityComponent {
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.hbarEngagementRatePerEntity$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('hbarEngagementRatePerEntity');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getHbarEngagementRatePerEntity().subscribe();
  }

  get data() {
    return this.analyticsService.hbarEngagementRatePerEntity$.value;
  }
}
